import { render, staticRenderFns } from "./MentalHealth.vue?vue&type=template&id=046fa8a0&scoped=true&"
import script from "./MentalHealth.vue?vue&type=script&lang=js&"
export * from "./MentalHealth.vue?vue&type=script&lang=js&"
import style0 from "./MentalHealth.vue?vue&type=style&index=0&id=046fa8a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046fa8a0",
  null
  
)

export default component.exports